module.exports = __webpack_public_path__ + "img/unlock.931233e1.svg";